import Application from "./base/Application"
import config from "./config"
import context from "./context"
import store from "./store"
import routes from "./routes"
import plugins from "./plugins"
import App from "./App.vue"
import moment from "moment"

moment.locale("ru")

/**
 * Запустить приложение
 */
const run = async () => {
	// Авторизовать пользовтеля
	await context.authService.auth()

	// Инициализировать приложение
	const app = new Application(App, {
		config: config.app,
		store,
		routes,
		plugins,
		context
	})

	// Монтировать приложение
	app.mount("#app")
}

// Запустить приложение
run()
